export abstract class InputLengths {
  static readonly GENERIC_MAX_LENGTH: number = 255;
  static readonly GENERIC_MODIFIED_BY_MAX_LENGTH = 20;
}
